module.exports = __webpack_public_path__ + "static/media/GOOGLEPAY.010b242d.svg";